export enum Role {
  ADMINISTRADOR = 'administrador',
  TUTOR = 'tutor',
  CSM = 'csm',
  PROFESOR = 'profesor',
  RESIDENTE = 'residente',
  PARTICIPANTE = 'participante',
}

export default Role;
